import { Button, Table, } from "antd";
import { useState } from "react";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import DebouncedSearchInput from "../../Pages/SuperAdmin/Organizations/DebouncedSearchInput";

const IndustryTypeTable = ({ dataProps }) => {
  const { data, loader, actions } = dataProps;
  const [searchQuery, setSearchQuery] = useState("");

  const columns = [
    {
      title: 'Industry Types',
      dataIndex: 'name',
      align:'center'
    },
    {
      title: 'Actions',
      key: 'actions',
      align:'center',

      render: (text, record) => (
        <div>
          {/* Edit button */}

          <Button

            type="link"
            onClick={() => {
              actions.setIndustryTypeIdToEdit(record._id);
              actions.fetchIndustryTypeUpdate(record._id);

            }}
            style={{ marginRight: 8 }}
          >
            <AiOutlineEdit />
          </Button>

          {/* Delete button */}
          <Button
            shape="circle"
            danger
            type="link"

            onClick={() => {
              actions.setIndustryTypeIdToDelete(record._id);
              actions.setConfirmationModalOpen(true);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </div>
      ),
    },
  ]

  const filteredIndustryTypes = data?.filter((industryType) => {
    return industryType.name?.toLowerCase().includes(searchQuery.toLowerCase())
  }
  );
  return (
    <div>
      <div className="mb-4">
        <DebouncedSearchInput
          data={{
            search: searchQuery,
            setSearch: setSearchQuery,
            placeholder: "Search Agent Type",
          }}
        />
      </div>
      <Table
        loading={loader}
        columns={columns}
        dataSource={filteredIndustryTypes}
        pagination={{
          pageSize: 10,
          total: filteredIndustryTypes?.length,
        }}
        scroll={{ x: true, y: '50vh' }}
        bordered
        responsive
      />
    </div>
  );
};

export default IndustryTypeTable;